import type { Ebook } from '@/content/ebookBuilder'
import { EYEBROW, SERIES_BODY } from '@/content/ebookBuilder'
import { DOWNLOAD } from '@/content/pages/ebook-the-ai-corridor'

/**
 * "The AI Corridor" on the e-books index.
 *
 * Its own page (`content/pages/ebook-the-ai-corridor.ts`) shipped without a card
 * here, so the book existed at its address and nothing on
 * `/en/impact-labs/ebooks` led to it — which is what this file fixes. `href`
 * points at the designed page, so the card opens that rather than the generated
 * template, exactly as the Agentic AI and Transform Better entries do.
 *
 * **Built as a literal rather than with `ebook()`**, which is the one departure
 * from this folder's README. That helper derives the cover from an imported
 * WordPress crop (`…-384.webp` / `…-400.webp`); this book's cover is new media
 * in `photo-src/`, and `pnpm images` writes 640 and 1254 variants for it. Naming
 * them here is the difference between a card with artwork and a broken image.
 * `imported` is only what `splitEbookBlocks` matches the old index's blocks on,
 * and this book was never in that import, so it carries the cover's own path.
 *
 * No `check`: the page answers the summary, the address and the download itself.
 */
export const added: Ebook = {
  slug: 'the-ai-corridor',
  title: 'The AI Corridor: Finding Your AI Posture',
  eyebrow: EYEBROW,
  imported: '/photo/the-ai-corridor-ebook-artwork.png',
  cover: {
    src: '/photo/the-ai-corridor-ebook-artwork-640.webp',
    srcSet:
      '/photo/the-ai-corridor-ebook-artwork-640.webp 640w, '
      + '/photo/the-ai-corridor-ebook-artwork-1254.webp 1254w',
    alt: 'The AI Corridor: Finding Your AI Posture cover',
    width: 1254,
    height: 1254,
  },
  body: SERIES_BODY,
  download: DOWNLOAD,
  href: '/en/impact-labs/ebooks/the-ai-corridor',
}

/** Ahead of the imported seventeen, which carry 0–16: this is the newest book. */
export const order = -1
